import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Header from '@/components/Header'
import Main from '@/components/Main'
import Footer from '@/components/Footer'
import Index from '@/components/Index'
import About from '@/components/About'
import AboutCompany from '@/components/AboutCompany'
import AboutTeam from '@/components/AboutTeam'
import AboutEqp from '@/components/AboutEqp'
import AboutTech from '@/components/AboutTech'
import AboutPartners from '@/components/AboutPartners'
import AboutVideo from '@/components/AboutVideo'
import Business from '@/components/Business'
import System from '@/components/System'
import Product from '@/components/Product'
import ProductCategory from '@/components/ProductCategory'
import ProductDetail from '@/components/ProductDetail'
import Case from '@/components/Case'
import CaseCategory from '@/components/CaseCategory'
import CaseDetail from '@/components/CaseDetail'
import Contact from '@/components/Contact'
import Map from '@/components/Map'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Index',
      component: Index,
      redirect: '/main',
      children: [{
          path: '/main',
          name: 'Main',
          component: Main
        },
        {
          path: '/about',
          name: 'About',
          component: About,
          redirect: 'about/company',
          children: [{
              path: '/about/company',
              name: 'AboutCompany',
              component: AboutCompany
            },
            {
              path: '/about/team',
              name: 'AboutTeam',
              component: AboutTeam
            },
            {
              path: '/about/eqp',
              name: 'AboutEqp',
              component: AboutEqp
            },
            {
              path: '/about/tech',
              name: 'AboutTech',
              component: AboutTech
            },
            {
              path: '/about/partners',
              name: 'AboutPartners',
              component: AboutPartners
            },
            {
              path: '/about/video',
              name: 'AboutVideo',
              component: AboutVideo
            },
          ]
        },
        {
          path: '/business',
          name: 'Business',
          component: Business
        },
        {
          path: '/system',
          name: 'System',
          component: System
        },
        {
          path: '/product',
          name: 'Product',
          component: Product
        },
        {
          path: '/product-category',
          name: 'ProductCategory',
          component: ProductCategory
        },
        {
          path: '/product-detail/:id',
          name: 'ProductDetail',
          component: ProductDetail
        },
        {
          path: '/case',
          name: 'Case',
          component: Case
        },
        {
          path: '/case-category',
          name: 'CaseCategory',
          component: CaseCategory
        },
        {
          path: '/case-detail/:id',
          name: 'CaseDetail',
          component: CaseDetail
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact
        }
      ]
    },
    {
      path: '/header',
      name: 'Header',
      component: Header
    },
    {
      path: '/footer',
      name: 'Footer',
      component: Footer
    },
    {
      path: '/hello',
      name: 'Hello',
      component: HelloWorld
    },
    {
      path: '/map',
      name: 'Map',
      component: Map
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js